/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Invite_Code_RequiredInputs */

const en_admin_settings_fields_invite_code_required = /** @type {(inputs: Admin_Settings_Fields_Invite_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Require invite code on sign up`)
};

const zh_admin_settings_fields_invite_code_required = /** @type {(inputs: Admin_Settings_Fields_Invite_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册时需要邀请码`)
};

/**
* | output |
* | --- |
* | "Require invite code on sign up" |
*
* @param {Admin_Settings_Fields_Invite_Code_RequiredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_invite_code_required = /** @type {((inputs?: Admin_Settings_Fields_Invite_Code_RequiredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Invite_Code_RequiredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_invite_code_required(inputs)
	return zh_admin_settings_fields_invite_code_required(inputs)
});
export { admin_settings_fields_invite_code_required as "admin.settings.fields.invite_code_required" }